import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import { TemplateItem } from "@shared/types";

interface TemplateLibraryProps {
  organizationId: string;
}

export function TemplateLibrary({ organizationId }: TemplateLibraryProps) {
  // This would be a real API call in production
  const { data: templates, isLoading } = useQuery<TemplateItem[]>({
    queryKey: [`/api/templates?organizationId=${organizationId}&popular=true`],
  });

  // Mock data for development
  const mockTemplates: TemplateItem[] = [
    {
      id: '1',
      name: 'Level 10 Meeting Agenda',
      category: 'meeting',
      icon: 'file-document-outline'
    },
    {
      id: '2',
      name: 'Quarterly Planning Template',
      category: 'meeting',
      icon: 'file-document-outline'
    },
    {
      id: '3',
      name: 'Coaching Session Guide',
      category: 'coaching',
      icon: 'file-document-outline'
    },
    {
      id: '4',
      name: 'New Hire Onboarding',
      category: 'onboarding',
      icon: 'file-document-outline'
    }
  ];

  const data = templates || mockTemplates;

  return (
    <Card className="p-4">
      <CardHeader className="p-0 pb-4 flex flex-row space-y-0 justify-between items-center gap-2">
        <CardTitle className="text-lg font-medium text-left">Template Library</CardTitle>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <span className="mdi mdi-dots-vertical text-neutral-500"></span>
        </Button>
      </CardHeader>
      <CardContent className="p-0">
        {isLoading ? (
          <div className="space-y-3">
            {[...Array(4)].map((_, index) => (
              <Skeleton key={index} className="h-10 w-full" />
            ))}
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((template) => (
              <div 
                key={template.id} 
                className="flex items-center justify-between p-2 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded cursor-pointer"
              >
                <div className="flex items-center">
                  <span className={`mdi mdi-${template.icon} text-primary text-xl mr-2`}></span>
                  <span className="text-sm">{template.name}</span>
                </div>
                <span className="mdi mdi-content-copy text-neutral-500"></span>
              </div>
            ))}
            
            <Button variant="ghost" className="mt-2 w-full">
              <span className="mdi mdi-folder-multiple mr-1"></span>
              View All Templates
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
